import Vue from 'vue'
import Vuex from 'vuex'
import jwtDecode from 'jwt-decode'
import moment from 'moment'

Vue.use(Vuex)

const state = {
  token: sessionStorage.getItem('user_token'),
  refreshToken: localStorage.getItem('refresh_token'),
  loginError: null,
  alerts: [],
  showHeaderEvents: false,
  selectedHeaderEvent: localStorage.getItem('header_event'),
  showSidebar: false,
  viewSelection: 0,
}

const getters = {
  token: state => {
    return state.token
  },

  refreshToken: state => {
    return state.refreshToken
  },

  loginError: state => {
    return state.loginError
  },

  currentUser: state => {
    let user = null;
    if (state.token) {
      user = jwtDecode(state.token);
      if (!user.role) {
        user.role = []
      }
      if (typeof user.role === 'string') {
        user.role = [user.role]
      }
    }
    return user;
  },

  alerts: state => {
    return state.alerts;
  },
  headerEvents: state => {
    return state.headerEvents;
  },
  selectedHeaderEvent: state => {
    return state.selectedHeaderEvent
  },
  showSidebar: state => {
    return state.showSidebar;
  },
  viewSelection: state => {
    return state.viewSelection;
  }
}

const mutations = {
  LOGIN_SUCCESS(state, payload) {
    state.token = payload.token
    state.refreshToken = payload.refreshToken
    state.loginError = null
  },

  LOGIN_FAILURE(state, error) {
    state.token = null
    state.refreshToken = null
    state.loginError = error
  },

  SET_REFRESH_TOKEN(state, token) {
    state.refreshToken = token;
  },

  REFRESH_SUCCESS(state, payload) {
    state.token = payload.token
    state.refreshToken = payload.refreshToken
    state.loginError = null
  },

  REFRESH_FAILURE(state, error) {
    state.token = null
    state.refreshToken = null
    state.loginError = error
  },

  LOGOUT(state) {
    state.token = null
    state.refreshToken = null
    state.loginError = null
  },

  PUSH_ALERT(state, alert) {
    alert.timestamp = moment.utc().toISOString();
    state.alerts.push(alert);
  },

  REMOVE_ALERT(state, index) {
    state.alerts.splice(index, 1);
  },
  
  REMOVE_ALERT_BY_TEXT(state, text){
    state.alerts = state.alerts.filter(alert=>{
      return alert.message !== text;  
    })
  },
  
  CLEAN_ALERTS(state){
    state.alerts = [];
  },

  SET_SELECTED_HEADER_EVENT(state, event) {
    state.selectedHeaderEvent = event
    localStorage.setItem('header_event', event);
  },
  SET_SHOW_SIDEBAR(state, showSidebar) {
    state.showSidebar = showSidebar;
  },
  CHANGE_VIEW_SELECTION(state, viewSelection) {
    state.viewSelection = viewSelection;
  },
}

const actions = {
  login(context, auth) {
    let loginData = {email: auth.email, password: auth.password}

    return Vue.axios.post('/authentication/login', loginData)
      .then(response => {
        sessionStorage.setItem('user_token', response.data.token)
        localStorage.setItem('refresh_token', response.data.refreshToken)
        context.commit('LOGIN_SUCCESS', {token: response.data.token, refreshToken: response.data.refreshToken})
      }).catch((error) => {
        context.commit('LOGIN_FAILURE', error)
        throw error
      })
  },
  refresh(context) {
    return Vue.axios.post('/authentication/refresh', {refreshToken: context.state.refreshToken},{withCredentials: true,})
      .then(response => {
        sessionStorage.setItem('user_token', response.data.token)
        localStorage.setItem('refresh_token', response.data.refreshToken)
        context.commit('REFRESH_SUCCESS', {token: response.data.token, refreshToken: response.data.refreshToken})
      }).catch((error) => {
        context.commit('REFRESH_FAILURE', error)
        throw error
      })
  },
  async logout(context) {
    let refreshToken = context.getters.refreshToken;
    sessionStorage.removeItem('user_token')
    localStorage.removeItem('refresh_token')
    context.commit('LOGOUT')
    await Vue.axios.post(`/authentication/logout`, {token: refreshToken})
  },
  toggleSidebar(context) {
    context.commit('SET_SHOW_SIDEBAR', !context.state.showSidebar);
  },
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  getters,
  mutations,
  actions
})
